export default __webpack_public_path__ + "static/media/GardenImage.6f484998.svg";